import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  FileField,
  BooleanInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  ImageInput,
  ImageField,
} from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { initialValues, languageChoices, projectType } from "utils/options";
import { Grid } from "@mui/material";
import CustomDateInput from "common/components/Fields/CustomDateInput";
const currentDate = new Date().toISOString().split("T")[0];

const CreateProjects = () => {
  const transform = data => ({
    ...data,
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });
  return (
    <Create
      title="Създаване на проект"
      transform={transform}
    >
      <SimpleForm defaultValues={initialValues}>
        <Grid
          container
          spacing={5}
        >
          <Grid
            item
            xs={5}
          >
            <SelectInput
              label="Език"
              source="language"
              choices={languageChoices}
              fullWidth
              validate={required()}
            />
            <CustomDateInput
              label="Начална дата"
              source="starting_on"
              defaultValue={currentDate}
            />
            <CustomDateInput
              label="До дата"
              source="ending_on"
            />
            <CustomDateInput
              label="Дата на публикуване"
              source="started_on"
              validate={required()}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={5}
          >
            <SelectInput
              label="Тип проект"
              source="project_type"
              choices={projectType}
              validate={required()}
              fullWidth
            />
            <TextInput
              label="№ Проект"
              source="project_number"
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextInput
              label="Програма"
              source="program"
              fullWidth
              multiline
            />
            <TextInput
              label="Заглавие на проекта"
              source="title"
              fullWidth
              multiline
            />

            <TextInput
              label="Общ бюджет "
              source="common_budget"
              fullWidth
            />
            <TextInput
              label="Бюджет на Български пощи"
              source="budget_of_bulgarian_posts"
              fullWidth
            />
            <TextInput
              label="Срок за изпълнение"
              source="deadline_for_implementations"
              fullWidth
            />
            <TextInput
              label="Ръководител на проекта"
              source="project_manager"
              fullWidth
            />
            <TextInput
              label="Партньори"
              source="partners"
              fullWidth
              multiline
            />
            <TextInput
              label="Фонд"
              source="fund"
              fullWidth
            />
            <TextInput
              label="Практиканти"
              source="participant"
              fullWidth
            />
            <RichTextInput
              label="Съдържание"
              source="content"
              fullWidth
            />
            <RichTextInput
              label="Допълнителна информация"
              source="additional_information"
              fullWidth
            />
            <ImageInput
              placeholder="Добавете снимка"
              label="Снимка"
              source="image"
              accept="image/*"
              validate={required()}
            >
              <ImageField
                source="src"
                title="title"
              />
            </ImageInput>

            <ArrayInput
              source="files"
              label="Файлове"
            >
              <SimpleFormIterator
                disableReordering
                fullWidth
              >
                <FileInput
                  placeholder="Кликнете за да добавите файл"
                  label="Файл"
                  source="file"
                  maxSize={54525952}
                >
                  <FileField
                    source="src"
                    title="title"
                  />
                </FileInput>
                <TextInput
                  label="Име на файла"
                  source="name"
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>

            <BooleanInput
              label="Скрита"
              source="is_hidden"
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default CreateProjects;
